import { Navigate, Route, Routes } from "react-router-dom";
import { AdminRoute } from "./components/AdminRoute";
import { ContractorRoute } from "./components/ContractorRoute";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./hooks/useAuth";
import { AuthCallback } from "./pages/AuthCallback";
import { AuthConfirm } from "./pages/AuthConfirm";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { NotFound } from "./pages/NotFound";
import { Profile } from "./pages/Profile";
import { PropertyPage } from "./pages/Property";
import { Rent } from "./pages/Rent";
import { RepairChat } from "./pages/RepairChat";
import { Repairs } from "./pages/Repairs";
import { VideoTriage } from "./pages/VideoTriage";
import { AdminApprovals } from "./pages/admin/AdminApprovals";
import { AdminAudit } from "./pages/admin/AdminAudit";
import { AdminCommunications } from "./pages/admin/AdminCommunications";
import { AdminCompliance } from "./pages/admin/AdminCompliance";
import { AdminContractors } from "./pages/admin/AdminContractors";
import { AdminInvites } from "./pages/admin/AdminInvites";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AdminProperties } from "./pages/admin/AdminProperties";
import { AdminRepairs } from "./pages/admin/AdminRepairs";
import { AdminTenancies } from "./pages/admin/AdminTenancies";
import { AdminTenants } from "./pages/admin/AdminTenants";
import { ContractorLayout } from "./pages/contractor/ContractorLayout";
import { ContractorRepairDetail } from "./pages/contractor/ContractorRepairDetail";
import { ContractorRepairs } from "./pages/contractor/ContractorRepairs";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/confirm" element={<AuthConfirm />} />
        <Route path="/video-triage" element={<VideoTriage />} />
        <Route
          path="/contractor"
          element={
            <ProtectedRoute>
              <ContractorRoute>
                <ContractorLayout />
              </ContractorRoute>
            </ProtectedRoute>
          }
        >
          <Route index element={<ContractorRepairs />} />
          <Route path=":repairId" element={<ContractorRepairDetail />} />
        </Route>
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="property" element={<PropertyPage />} />
          <Route path="rent" element={<Rent />} />
          <Route path="repairs" element={<Repairs />} />
          <Route path="repairs/chat" element={<RepairChat />} />
          <Route path="profile" element={<Profile />} />
          <Route
            path="admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<Navigate to="properties" replace />} />
            <Route path="properties" element={<AdminProperties />} />
            <Route path="tenancies" element={<AdminTenancies />} />
            <Route path="tenants" element={<AdminTenants />} />
            <Route path="compliance" element={<AdminCompliance />} />
            <Route path="repairs" element={<AdminRepairs />} />
            <Route path="communications" element={<AdminCommunications />} />
            <Route path="approvals" element={<AdminApprovals />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="contractors" element={<AdminContractors />} />
            <Route path="invites" element={<AdminInvites />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
